module.exports = __webpack_public_path__ + "img/lasso.2665dadc.gif";